import "./App.css";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/hero";
import { TrustBar } from "./components/TrustBar";
import { HandmadeSoaps } from "./components/HandmadeSoaps";
import { ProductCategories } from "./components/ProductCategories";
import { BestSellers } from "./components/BestSellers";
import { Wholesale } from "./components/Wholesale";
import { Locations } from "./components/Locations";
import { Testimonials } from "./components/Testimonials";
import { Faq } from "./components/Faq";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { ContactProvider } from "./contexts/ContactContext";

function App() {
  return (
    <ContactProvider>
      <div className="App min-h-screen bg-[#FAFAF9]">
        <Toaster position="top-center" richColors />
        <Navbar />
        <main>
          <Hero />
          <TrustBar />
          <HandmadeSoaps />
          <ProductCategories />
          <BestSellers />
          <Wholesale />
          <Locations />
          <Testimonials />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </ContactProvider>
  );
}

export default App;